/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DodoPizzaLogo from 'shared/assets/logos/DodoPizza/DodoPizza.svg?react';
import Doner42Logo from 'shared/assets/logos/Doner42/Doner42.svg?react';
import DrinkitLogo from 'shared/assets/logos/Drinkit/Drinkit.svg?react';
import { MpTitle } from 'shared/ui/MpTitle';

interface ApplicationConceptionsMProps {
	conceptions: string[];
}

const ContainerStyled = styled.div`
	gap: 12px;
	display: flex;
`;

export const ApplicationConceptionsM: FC<ApplicationConceptionsMProps> = ({ conceptions }) => {
	const { t } = useTranslation();

	const title = t(`Marketplace_Concepts`);

	const logos = conceptions.map(conception => {
		switch (conception) {
			case `Drinkit`:
				return (
					<div style={{ width: `32px` }}>
						<DrinkitLogo />
					</div>
				);
			case `Doner42`:
				return (
					<div style={{ width: `32px` }}>
						<Doner42Logo />
					</div>
				);
			case `Dodo Pizza`:
				return (
					<div style={{ width: `32px` }}>
						<DodoPizzaLogo />
					</div>
				);
			// eslint-disable-next-line sonarjs/no-duplicated-branches
			default:
				return (
					<div style={{ width: `32px` }}>
						<Doner42Logo />
					</div>
				);
		}
	});

	return (
		<div style={{ marginBottom: `24px` }}>
			<MpTitle>{title}</MpTitle>
			<ContainerStyled>{logos}</ContainerStyled>
		</div>
	);
};
